export default "__VITE_ASSET__SNLjDF_X__"